import { Injectable } from '@angular/core';
import { TAvailabilityView } from '@x/ecommerce-shop/app/core/availability/availability';
import { AvailabilityService } from '@x/ecommerce-shop/app/core/availability/availability.service';
import { IShopOrderItem } from '@x/ecommerce/shop-client';
import { OrderItemSource } from '@x/schemas/ecommerce';

export interface IShopOrderItemView extends IShopOrderItem {
  availabilityView?: TAvailabilityView;
}

@Injectable()
export class OrderItemViewService {
  statusesInList: OrderItemSource[] = [OrderItemSource.Order, OrderItemSource.Promotional];

  constructor(private availabilityService: AvailabilityService) {}

  makeView(orderItem: IShopOrderItem): IShopOrderItemView {
    const { availability } = orderItem;

    return {
      ...orderItem,
      ...(availability && {
        availabilityView: this.availabilityService.getAvailabilityView({
          isAvailable: availability.isAvailable,
          minAvailableDate: availability.minAvailableDate,
          maxAvailableDate: availability.maxAvailableDate,
          maxAvailableQuantity: availability.maxAvailableQuantity,
          unavailableReason: availability.unavailableReason,
          showDefault: true,
        }),
      }),
    };
  }

  makeList(orderItems: IShopOrderItem[]): IShopOrderItemView[] {
    return orderItems
      .filter((i) => this.statusesInList.includes(i.source))
      .map((item) => this.makeView(item));
  }
}
